export default __webpack_public_path__ + "c24c03e6cbda08d139f6d63e91e3037d.svg";